import { createRequestBuilder, AsyncUtil } from '@quickplay/foundation';
import { PlatformAuthorizer, AuthorizationUtil } from '@quickplay/platform-authorizer';
import { StreamConcurrencyConfiguration } from '../StreamConcurrencyConfiguration';
import { StreamConcurrencyService } from '../StreamConcurrencyService';
import { StreamConcurrencyRequest } from './StreamConcurrencyRequest';

export const HEARTBEAT_TOKEN_HEADER_KEY = 'X-Heartbeat';

export function createStreamConcurrencyServiceImpl(
  streamConcurrencyEndPointUrl: string,
  platform: PlatformAuthorizer,
  configuration?: StreamConcurrencyConfiguration,
): StreamConcurrencyService {
  const maxRetries = configuration && configuration.maxRetries;
  const streamConcurrencyService: StreamConcurrencyService = {
    putStreamForDeviceId(deviceId: string, heartbeatToken?: string): Promise<void> {
      return putStreamForDeviceId(deviceId, heartbeatToken);
    },

    deleteStreamForDeviceId(deviceId: string): Promise<void> {
      return deleteStreamForDeviceId(deviceId);
    },
  };

  async function putStreamForDeviceId(deviceId: string, heartbeatToken?: string): Promise<void> {
    try {
      const streamConcurrencyRequest: StreamConcurrencyRequest = {
        deviceId: deviceId,
      };
      const request = createRequestBuilder<StreamConcurrencyRequest>()
        .url(streamConcurrencyEndPointUrl)
        .path(`/user/stream/create`)
        .put(streamConcurrencyRequest)
        .headers({
          accept: 'application/json',
          ...(heartbeatToken && { [HEARTBEAT_TOKEN_HEADER_KEY]: heartbeatToken }),
        })
        .build();
      AsyncUtil.retryOnNetworkFailure(
        () => AuthorizationUtil.makeAuthorizedRequest<any, void>(request, platform),
        maxRetries,
      );
      return Promise.resolve();
    } catch (error) {
      return Promise.reject(error);
    }
  }

  async function deleteStreamForDeviceId(deviceId: string): Promise<void> {
    try {
      const streamConcurrencyRequest: StreamConcurrencyRequest = {
        deviceId: deviceId,
      };
      const request = createRequestBuilder<StreamConcurrencyRequest>()
        .url(streamConcurrencyEndPointUrl)
        .path(`/user/stream/delete/${deviceId}`)
        .delete(streamConcurrencyRequest)
        .headers({ accept: 'application/json' })
        .build();
      AsyncUtil.retryOnNetworkFailure(
        () => AuthorizationUtil.makeAuthorizedRequest<any, void>(request, platform),
        maxRetries,
      );
      return Promise.resolve();
    } catch (error) {
      return Promise.reject(error);
    }
  }

  return streamConcurrencyService;
}
